// Curated list of Google Fonts grouped by intended role.
// Each entry is { name, weights } where `name` is what we store in the DB and
// what the CSS uses as the font family.

export type FontDef = { name: string; weights: string };

export const HEADING_FONTS: FontDef[] = [
  { name: "Cormorant Garamond", weights: "ital,wght@0,400;0,500;0,600;1,400" },
  { name: "Playfair Display", weights: "ital,wght@0,400;0,600;0,700;1,400" },
  { name: "EB Garamond", weights: "ital,wght@0,400;0,500;0,600;1,400" },
  { name: "Cardo", weights: "ital,wght@0,400;0,700;1,400" },
  { name: "Fraunces", weights: "ital,wght@0,400;0,500;0,600;1,400" },
  { name: "DM Serif Display", weights: "ital,wght@0,400;1,400" },
  { name: "Cormorant", weights: "ital,wght@0,400;0,500;0,600;1,400" },
  { name: "Crimson Pro", weights: "ital,wght@0,400;0,500;0,600;1,400" },
  { name: "Libre Caslon Text", weights: "ital,wght@0,400;0,700;1,400" },
  { name: "Lora", weights: "ital,wght@0,400;0,500;0,600;1,400" },
  { name: "Montserrat", weights: "ital,wght@0,300;0,400;1,300;1,400" },
];

export const BODY_FONTS: FontDef[] = [
  { name: "Inter", weights: "wght@400;500;600" },
  { name: "Work Sans", weights: "wght@400;500;600" },
  { name: "DM Sans", weights: "wght@400;500;600" },
  { name: "Manrope", weights: "wght@400;500;600" },
  { name: "Source Sans 3", weights: "wght@400;500;600" },
  { name: "Nunito Sans", weights: "wght@400;500;600" },
  { name: "Plus Jakarta Sans", weights: "wght@400;500;600" },
  { name: "Outfit", weights: "wght@400;500;600" },
  { name: "Lato", weights: "wght@400;500;600" },
  { name: "Public Sans", weights: "wght@400;500;600" },
  { name: "Instrument Sans", weights: "wght@400;500;600" },
];

export function findFont(list: FontDef[], name: string): FontDef {
  return list.find((f) => f.name === name) ?? list[0];
}

export function googleFontsUrl(heading: FontDef, body: FontDef): string {
  const fam = (f: FontDef) =>
    `family=${encodeURIComponent(f.name).replace(/%20/g, "+")}:${f.weights}`;
  return `https://fonts.googleapis.com/css2?${fam(heading)}&${fam(body)}&display=swap`;
}
